<div *ngIf="isVisible" class="alert alert-danger alert-dismissible fade show" role="alert">
  <div class="d-flex align-items-start">
    <i class="bi bi-exclamation-circle-fill me-2 flex-shrink-0" style="font-size: 1.2rem"></i>
    <div class="flex-grow-1">
      <strong class="d-block mb-2">Error</strong>
      <ul class="mb-0" [class.list-unstyled]="parsedErrors.length === 1" [class.ps-0]="parsedErrors.length === 1">
        <li *ngFor="let error of parsedErrors" [class.mb-1]="parsedErrors.length > 1">
          <strong *ngIf="error.field && showFieldNames">{{ getFieldLabel(error.field) }}:</strong>
          {{ error.message }}
        </li>
      </ul>
    </div>
    <button *ngIf="dismissible" type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
  </div>
</div>
